import type { OnboardingAnswer } from '../types/onboarding';
import { api, type ApiResponse } from '../utils';

const getOnboardingSections = async (): Promise<ApiResponse> => {
  try {
    const response = await api.get('/onboarding/sections');
    return response.data;
  } catch (error: any) {
    return {
      code: error?.code || 500,
      message: error?.message || 'Failed to sign up',
      result: null,
    };
  }
};

const getOnboardingQuestionsBySection = async (
  id: string
): Promise<ApiResponse> => {
  try {
    const response = await api.get(`/onboarding/questions/${id}`);
    return response.data;
  } catch (error: any) {
    return {
      code: error?.code || 500,
      message: error?.message || 'Failed to sign up',
      result: null,
    };
  }
};

const uploadResume = async (file: File): Promise<ApiResponse> => {
  const formData = new FormData();
  formData.append('file', file);

  try {
    const response = await api.post('/onboarding/upload-resume', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error: any) {
    return {
      code: error?.code || 500,
      message: error?.message || 'Failed to upload resume',
      result: null,
    };
  }
};

const submitOnBoardingSection = async (
  data: OnboardingAnswer
): Promise<ApiResponse> => {
  try {
    const response = await api.post('/onboarding/submit-section', data);
    return response.data;
  } catch (error: any) {
    return {
      code: error?.code || 500,
      message: error?.message || 'Failed to submit onboarding section',
      result: null,
    };
  }
};

const updateOnBoardingSection = async (
  data: OnboardingAnswer
): Promise<ApiResponse> => {
  try {
    const response = await api.post('/onboarding/update-section', data);
    return response.data;
  } catch (error: any) {
    return {
      code: error?.code || 500,
      message: error?.message || 'Failed to update onboarding section',
      result: null,
    };
  }
};

const getOnboardingSummary = async (): Promise<ApiResponse> => {
  try {
    const response = await api.get('/onboarding/answers');
    return response.data;
  } catch (error: any) {
    return {
      code: error?.code || 500,
      message: error?.message || 'Failed to get onboarding summary',
      result: null,
    };
  }
};

const requestAISummary = async (): Promise<ApiResponse> => {
  try {
    const response = await api.post('/onboarding/request-ai-summary');
    return response.data;
  } catch (error: any) {
    return {
      code: error?.code || 500,
      message: error?.message || 'Failed to get ai summary',
      result: null,
    };
  }
};

const approveAISummary = async (id: string): Promise<ApiResponse> => {
  const { data: response } = await api.post(
    `/onboarding/approve-ai-summary/${id}`
  );
  return response;
};

const resetOnboarding = async (): Promise<ApiResponse> => {
  try {
    const response = await api.post('/onboarding/reset-data');
    return response.data;
  } catch (error: any) {
    return {
      code: error?.code || 500,
      message: error?.message || 'Failed to reset onboarding',
      result: null,
    };
  }
};

export {
  getOnboardingSections,
  getOnboardingQuestionsBySection,
  uploadResume,
  submitOnBoardingSection,
  updateOnBoardingSection,
  getOnboardingSummary,
  requestAISummary,
  approveAISummary,
  resetOnboarding,
};
